<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                    <p class="modal-close" @click="$emit('close')">
                            X
                    </p>
                    <div class="modal-header">
                        <slot name="header">
                        default header
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                        default body
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                        default footer
                        </slot>
                    </div>
                    </div>
                </div>
            </div>
      </transition>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            selectedModalContent: Object
        },
        data() {
            return {
                cas9: 'cas notes',
                deam: 'deam notes',
                arch: 'arch notes',
            }
        },
    }
</script>